import React from 'react'
import { DragSource } from 'react-dnd'
import ItemTypes from '~/utils/TemplateEditor/dragDropItemTypes'
import * as siteMaster from '~/data/actions/siteActions'
import DeleteBlockDrawer from './deleteBlockDrawer'
import { connect } from 'react-redux'
import axios from '~/data/http/axios'
import cloneDeep from 'lodash/cloneDeep'

const dragSource = {
    beginDrag(props) {
        // Hand over a private copy so we never mutate the shared palette object during hover/insert
        return { path: "", isNew: 0, content: cloneDeep(props.content) }
    },
    endDrag(props, monitor) {
    }
}

const NewHolderObject = ({ 
    connectDragSource, 
    isDragging, 
    id, 
    title, 
    type, 
    toolbarIcon, 
    content, 
    blockId, 
    updateBlocks, 
    dispatch 
}) => {
    const deleteBlock = (event) => {
        event.stopPropagation()
        event.preventDefault()
        const drawerContent = <DeleteBlockDrawer reallyDelete={goDeleteBlock} />
        dispatch(siteMaster.alterSiteDrawer(true, true, "right", drawerContent, true))
    }

    const goDeleteBlock = () => {
        dispatch(siteMaster.alterSiteDrawer(false, false, "right", undefined, false))
        axios
            .delete('/templateComponent/' + blockId)
            .then(() => {
                updateBlocks()
            })
    }

    if (type === "userBlock") {
        return connectDragSource(
            <div className="newElementObject" id={id}>
                <div style={{ display: "flex", height: "100%", width: "100%", alignItems: "center", justifyContent: "center" }}>
                    <div className="text-xsml">{title}</div>
                </div>
                <div className="icon-cross newElementCloseButt dndEditorv2-newElementCloseButt" onClick={deleteBlock} title="Delete Block" />
            </div>
        )
    }

    return connectDragSource(
        <div className="newElementObject" id={id}>
            <img src={toolbarIcon} className="newElementObject-icon" />
            <div className="newElementObject-text">{title}</div>
        </div>
    )
}

const wrappedComponent = DragSource(ItemTypes.NEWHOLDER, dragSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
}))(NewHolderObject)

export default connect((store) => {
    return { user: store.user, accountMaster: store.accountMaster }
})(wrappedComponent)